import { Alert, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { DATE_FORMATS } from "lib/@constants/date-format"

export function ScheduleReviewJustification() {
    // Only a rejected change has a justification to show. Gate on the (optimistic) decision
    // so approving hides the banner immediately; the reason text comes from the same decision
    // the buttons read, so it stays in step with the decisions list (no separate fetch).
    const { accepted, decisionPayload } = useBoundContext()
    if (accepted !== false) return null

    const reason = decisionPayload?.reason
    if (!reason) return null

    const { userName, actionedOn } = decisionPayload
    const actionedOnDisplay = actionedOn ? new Date(actionedOn).format(DATE_FORMATS.dateAndTime) : ""

    return (
        <Alert severity="error" sx={{ mb: 1 }} data-cy="schedule-review-banner">
            <Typography>{reason}</Typography>
            <Typography variant="body2">
                {userName} {actionedOnDisplay}
            </Typography>
        </Alert>
    )
}
